import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { KryptonElement } from './krypton-element';



export class SlideElement extends KryptonElement {

    static styles = css`
        :host {
            display: block;
        }
        .slide-element-holder{
            position: relative;
        }
    `;

    render() {
        return html`<slot></slot>`;
    }

    @property({ type: Boolean, reflect: true })
    accessor open = false;

}

declare global {
    interface HTMLElementTagNameMap {
        'slider-element': SlideElement;
    }
}
